import { __decorate, __metadata } from "tslib";
import { AppRequest } from '@core/shared/app-request';
import { AppRequestMethod } from '@core/shared/request';
import { Expose, Model, ModelId } from '@core/shared/model';
let RefreshMediaAssetReadyStateResponse = /*#__PURE__*/(() => {
  let RefreshMediaAssetReadyStateResponse = class RefreshMediaAssetReadyStateResponse extends Model {};
  __decorate([Expose(), __metadata("design:type", Boolean)], RefreshMediaAssetReadyStateResponse.prototype, "ready", void 0);
  RefreshMediaAssetReadyStateResponse = __decorate([ModelId("RefreshMediaAssetReadyStateResponse") // auto-generated by generate-model-ids
  ], RefreshMediaAssetReadyStateResponse);
  return RefreshMediaAssetReadyStateResponse;
})();
export { RefreshMediaAssetReadyStateResponse };
let RefreshMediaAssetReadyStateRequest = /*#__PURE__*/(() => {
  let RefreshMediaAssetReadyStateRequest = class RefreshMediaAssetReadyStateRequest extends Model {
    static {
      this.Response = RefreshMediaAssetReadyStateResponse;
    }
  };
  __decorate([Expose(), __metadata("design:type", Number)], RefreshMediaAssetReadyStateRequest.prototype, "assetId", void 0);
  RefreshMediaAssetReadyStateRequest = __decorate([AppRequest('media', 'assets/refresh-ready-state', {
    httpMethod: AppRequestMethod.POST
  }), ModelId("RefreshMediaAssetReadyStateRequest") // auto-generated by generate-model-ids
  ], RefreshMediaAssetReadyStateRequest);
  return RefreshMediaAssetReadyStateRequest;
})();
export { RefreshMediaAssetReadyStateRequest };